'use client';

import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { parseApiAsset } from '@morpho-org/dapp-core';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { useQuery } from '@tanstack/react-query';
import { useWeb3Context } from '@/contexts/Web3Context';
import { orpc } from '@/lib/orpc/client';
import { toRepayDialogMarket } from '../toRepayDialogMarket';
export const useRepayDialog = marketId => {
  const $ = _c(17);
  const {
    toggleDialog
  } = useDialogContext();
  const {
    targetChainId
  } = useWeb3Context();
  let t0;
  if ($[0] !== toggleDialog) {
    t0 = () => toggleDialog(false);
    $[0] = toggleDialog;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClose = t0;
  let t1;
  if ($[2] !== marketId || $[3] !== targetChainId) {
    t1 = orpc.market.repayDialog.queryOptions({
      input: {
        chainId: targetChainId,
        marketId
      },
      staleTime: Infinity
    });
    $[2] = marketId;
    $[3] = targetChainId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data,
    isPending: isQueryLoading,
    error: queryError
  } = useQuery(t1);
  let loanAsset;
  let market;
  let t2;
  if ($[5] !== data || $[6] !== targetChainId) {
    market = data ? toRepayDialogMarket(data, targetChainId) : undefined;
    loanAsset = parseApiAsset(market?.loanAsset);
    t2 = parseApiAsset(market?.collateralAsset);
    $[5] = data;
    $[6] = targetChainId;
    $[7] = loanAsset;
    $[8] = market;
    $[9] = t2;
  } else {
    loanAsset = $[7];
    market = $[8];
    t2 = $[9];
  }
  const collateralAsset = t2;
  let t3;
  if ($[10] !== collateralAsset || $[11] !== handleClose || $[12] !== isQueryLoading || $[13] !== loanAsset || $[14] !== market || $[15] !== queryError) {
    t3 = {
      handleClose,
      market,
      isQueryLoading,
      queryError,
      loanAsset,
      collateralAsset
    };
    $[10] = collateralAsset;
    $[11] = handleClose;
    $[12] = isQueryLoading;
    $[13] = loanAsset;
    $[14] = market;
    $[15] = queryError;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
};